import React from 'react';
import {getClassName} from "../../utils/StyleUtils";
import {configs} from "../../resources/configs";
import {MainResources} from "../../models/Resources";

export const TryApp = () => {

  return <div className={getClassName('try-screen-container')} id={'download'}>
      <img className={getClassName('try-app-img')} src={MainResources.tryApp.blobSrc}/>

      <div style={{position: 'absolute', bottom: '32px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
      <div style={{width: '182px', height: '56px'}}
           onClick={() => {
             window.open(configs.fltrIosUrl);
           }}
      />
      <div style={{width: '182px', height: '56px'}}
           onClick={() => {
             window.open(configs.fltrAndroidUrl);
           }}
      />
    </div>
  </div>;
}
